import { useState, useMemo } from 'react';
import type { ADStatusEvent, ApiEndpoints } from '@avisoma//shared';
import { Card } from '../../components/Card';
import { DescriptionList, DescriptionTerm, DescriptionDetails } from '../../catalyst/description-list';
import { ADTable } from '../../components/reconstructedDocument/extractionTables/ADTable';
import { ExtractionTableCard } from '../../components/reconstructedDocument/extractionTables/ExtractionTableCard';
import { RowInspectorDialog } from '../../components/reconstructedDocument/extractionTables/RowInspectorDialog';
import { SourceCard } from './SourceCard';
import { StatusPackWarnings } from './StatusPackWarnings';

interface ADEventsProps {
  response: ApiEndpoints<string>['/api/projects/:id']['GET']['response'];
}

export function ADEvents({ response }: ADEventsProps) {
  const data = response.item.data?.adEvents;
  const ads = data?.ads;
  const [inspected, setInspected] = useState<ADStatusEvent | null>(null);

  const pageIdToPosition = useMemo(() => {
    const map = new Map<string, number>();
    data?.pageIds.forEach((pageId, index) => map.set(pageId, index + 1));
    return map;
  }, [data?.pageIds]);

  if (!data || !ads) {
    return null;
  }

  return (
    <div className="space-y-6">
      <SourceCard sources={[{ documentId: data.documentId, pageIds: data.pageIds }]}>
        <StatusPackWarnings warnings={data.warnings} />
      </SourceCard>

      <Card header={<h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">AD Status Events</h2>}>
        <DescriptionList>
          <DescriptionTerm>AD Count</DescriptionTerm>
          <DescriptionDetails>{ads.length}</DescriptionDetails>
        </DescriptionList>
      </Card>

      <ExtractionTableCard label="AD Status Events" rows={ads} csvTitle="AD Status Events" bodyHeight="project">
        <ADTable rows={ads} pageIdToPosition={pageIdToPosition} onInspect={setInspected} />
      </ExtractionTableCard>

      <RowInspectorDialog
        open={inspected != null}
        onClose={() => setInspected(null)}
        title="AD Status row"
        data={inspected}
      />
    </div>
  );
}
